import { v4 as uuidv4 } from 'uuid';

/**
 *  Traverse and find connected cost category
 *
 * @param categoryId
 * @param costCategory
 */
const findConnected = (categoryId, categories) => {
  return categories
    .filter((category) => category.parentId === categoryId)
    .flatMap((category) => [category.costCategoryId, ...findConnected(category.costCategoryId, categories)]);
};

/**
 *  Traverse and find connected cost category
 *
 * @param costSetup
 * @param targetCategoryId
 */
export const findConnectedCategories = ({ costCategory, costItem }, targetCategoryId) => {
  const connectedCategories = findConnected(targetCategoryId, costCategory);
  connectedCategories.push(targetCategoryId);

  const resultItem = costItem.filter((item) => !connectedCategories.includes(item.parentId));
  const resultCategory = costCategory.filter(
    (item) => !connectedCategories.includes(item.costCategoryId || item.parentId),
  );
  return { costCategory: resultCategory, costItem: resultItem };
};

/**
 * @description Update parent ids for costSetup category and items
 *
 * @param {object[]} categories
 * @param {uuid} oldId
 * @param {uuid} newId
 * @returns {object[]} categories
 */
export const updateCostSetupIds = (categories, oldId, newId) => {
  return categories.map((category) => {
    if (category.parentId === oldId) {
      category.parentId = newId;
    }
    return category;
  });
};

/**
 * @description Update ids for activity model activities
 *
 * @param {object[]} activities
 * @param {object} operationIdsMap
 * @returns {object[]} activities
 */
export const updateActivityIds = (activities, operationIdsMap) => {
  return activities.map((activity) => {
    if (activity?.activities.length !== 0) {
      const newActivityId = operationIdsMap[activity.id] || uuidv4();
      activity.id = newActivityId;

      activity.activities = activity.activities.map((childActivity) => {
        if (childActivity?.parentId && childActivity.parentId === activity.id) {
          childActivity.parentId = newActivityId;
        }
        return childActivity;
      });
    }
    return activity;
  });
};

/**
 * @description Update ids for activity model activities
 *
 * @param {object[]} operations
 * @returns {object} operationIdsMap
 */
export const getOperationIdsMap = (operations) => {
  const operationIdsMap = {};
  operations.forEach((operation) => {
    const newOperationId = uuidv4();
    operationIdsMap[operation.id] = newOperationId;
  });
  return operationIdsMap;
};
